import React from "react";
import { BidFormValues } from "./types";
import { UseFormReturn } from "react-hook-form";
import { Switch } from "@/components/ui/switch";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormDescription,
} from "@/components/ui/form";

const SplitPayment = ({ form }: { form: UseFormReturn<BidFormValues> }) => {
  return (
    <div className="mb-6">
      <FormField
        control={form.control}
        name="splitPayment"
        render={({ field }) => (
          <FormItem>
            <div className="flex items-center gap-3 mb-1">
              <FormLabel className="mb-0">Split Payment</FormLabel>
              <FormControl>
                <Switch
                  checked={!!field.value}
                  onCheckedChange={field.onChange}
                />
              </FormControl>
            </div>
            <FormDescription className="ml-1 text-sm text-muted-foreground">
              If enabled, one invoice will be due now for 50% and another 28
              days before the event for the remaining 50%.
            </FormDescription>
          </FormItem>
        )}
      />
    </div>
  );
};

export default SplitPayment;
